import { StoreState } from '../../../store/store.interface';

export const getOpenOffCanvasAction = (state: StoreState) => state.offCanvasState?.openAction;

export const getClearOffCanvasAction = (state: StoreState) => state.offCanvasState?.clearAction;

export const getCloseOffCanvasAction = (state: StoreState) => state.offCanvasState?.closeAction;

export const getFocusInOffCanvasAction = (state: StoreState) => state.offCanvasState?.focusInAction;

export const getFocusOutOffCanvasAction = (state: StoreState) => state.offCanvasState?.focusOutAction;

export const getOffCanvasData = (state: StoreState) => state.offCanvasState?.data;
